import { z } from "zod";

export const MACHINE_VOLUME_MAX_ML = 20_000;

export const machineTypeSchema = z.enum(["churn", "mill"]);
export const machineNameSchema = z
  .string()
  .trim()
  .min(1, "Name is required")
  .max(50, "Name is too long");
export const machineVolumeMlSchema = z
  .number({ error: "Volume is required" })
  .int("Volume must be a whole number")
  .positive("Volume must be greater than zero")
  .max(MACHINE_VOLUME_MAX_ML, "Volume is too large");

export const machineDomainSchema = z.object({
  name: machineNameSchema,
  volumeMl: machineVolumeMlSchema,
  type: machineTypeSchema,
});
